export const ToolParticipationModeEnum = Object.freeze({
	SINGLE: "single",
	INDEPENDENT_MULTI: "independentMulti",
	INDEPENDENT_ANONYMOUS: "independentAnonymous",
	SHARED_STATE: "sharedState",
})
